const React = require('react');

const RowA = require('../../../../../dumb/Row/A');
const ColA = require('../../../../../dumb/Col/A');
const Tooltip = require('../../../../../dumb/Tooltip/A');
const toLower = require("mn-utils/toLower");
const upperFirst = require("mn-utils/upperFirst");
const {default: IconButton} = require("@material-ui/core/IconButton");
const openPopupKlubcoinFeeCompletion = require("../../utils/openPopupKlubcoinFeeCompletion");
const {default: PlayCircleIcon} = require("@material-ui/icons/PlayCircleOutlineOutlined");
const ColA2 = require("../../../../../dumb/Col/A2");

const {
  DisplayIdAdmin,
  DisplayAmountAdmin,
  DisplayDateTimeAdmin
} = require("../../../../../dumb/DisplayData");

const RowAction = ({title, action, icon: IC, disabled}) => {
  const btn = (
    <IconButton
      className="olN-i (o20):disabled"
      onClick={action}
      disabled={disabled}
    >
      <div className="sq23 layoutRow fhaC fvaC cF">
        {IC && <IC />}
      </div>
    </IconButton>
  )

  return disabled
    ? btn
    : (
      <Tooltip title={title} disabledCopy>
        {btn}
      </Tooltip>
    )
}

module.exports = ({data, update}) => {
  const {
    id,
    total_amount: amount,
    invoice_amount: fee,
    total_entries: trxCount,
  } = data;

  const isStablecoin = !!data.sc_code;
  const assetCode = isStablecoin ? data.sc_code : data.fiat_code;
  // const type = isStablecoin ? 'stablecoin' : 'fiat';
  const status = toLower(data.lifeflow || '');
  const time = data.created_at || '';

  const disableActions = data.lifeflow !== 'pending';

  return (
    <RowA className="f12">
      <ColA className="wmin155 fx1">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </ColA>
      <ColA className="wmin100 fx1">
        <DisplayAmountAdmin
          amount={amount}
          symbol={assetCode}
          type="fiat"
        />
      </ColA>
      <ColA className="wmin100 fx1">
        <DisplayAmountAdmin
          amount={fee}
          symbol={assetCode}
          type="fiat"
        />
      </ColA>
      <ColA className="wmin110">
        {trxCount}
      </ColA>
      <ColA className="wmin95">
        <DisplayDateTimeAdmin
          date={time}
        />
      </ColA>
      <ColA className="wmin100 fx1">
        <div
          className={`lh lts0em c0 cFFBF43.pending c2CE889.paid
              c8.canceled ` + status}
        >{upperFirst(status)}</div>
      </ColA>
      <ColA2 className="w56">
        <RowAction
          title="Complete Fee"
          action={() => openPopupKlubcoinFeeCompletion(data, update)}
          icon={PlayCircleIcon}
          disabled={disableActions}
        />
      </ColA2>
    </RowA>
  );
};
